// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'star-mixed';

export const Component = () => (
  <>
    <path
      fill='currentColor'
      d='m9 14.976-4.896 2.448c-.288.144-.648 0-.792-.288-.072-.144-.072-.288-.072-.432l1.44-5.328L.72 7.344a.565.565 0 0 1 0-.792.55.55 0 0 1 .36-.144l4.824-.504L8.424.936c.144-.216.288-.36.576-.36v14.4Z'
    />
    <path
      fill='none'
      stroke='currentColor'
      d='m9.576.864 2.52 4.968 4.824.504c.36 0 .576.288.576.648a.55.55 0 0 1-.144.36l-3.96 3.96 1.44 5.328c.072.36-.072.648-.432.72-.144.072-.288 0-.432-.072l-4.896-2.448-4.896 2.448c-.288.144-.648 0-.792-.288-.072-.144-.072-.288-.072-.432l1.44-5.328L.72 7.344a.565.565 0 0 1 0-.792.55.55 0 0 1 .36-.144l4.824-.504L8.424.936c.144-.288.504-.432.792-.288.144.072.288.144.36.216Z'
    />
  </>
);

export const viewBox = '0 0 18 18';
